import {CircularProgress} from "@mui/material";

export default function LoadingSpinner() {
	return (
		<CircularProgress size={30} sx={styles.loadingSpinner} />
	);
}

const styles = {
	loadingSpinner: {
		color: '#003300',
	}
}